<template>
  <el-container v-loading="isShow" element-loading-text="拼命加载中">
    <div class="comp">
      <div style="padding: 20px 20px 0 20px">
        <el-radio v-model="radio" label="shop">按门店</el-radio>
        <el-radio v-model="radio" label="branch">按部门</el-radio>
        <el-radio v-model="radio" label="staff">按个人</el-radio>
        <span v-if="radio === 'shop'" style="margin-left: 20px">职位：</span>
        <el-select
          v-if="radio === 'shop'"
          v-model="selectValue1"
          @change="changeSelectValue1"
          placeholder="请选择"
          size="small"
          style="width: 120px"
        >
          <el-option
            v-for="item in datas.shop_performance_list"
            :key="item.department"
            :label="item.department"
            :value="item.department"
          >
          </el-option>
        </el-select>
        <span v-if="radio === 'branch'" style="margin-left: 20px">周数：</span>
        <el-select
          v-if="radio === 'branch'"
          v-model="selectValue3"
          @change="changeSelectValue3"
          placeholder="请选择"
          size="small"
          style="width: 120px"
        >
          <el-option
            v-for="item in datas.branch_performances_list"
            :key="item.week_setting_item.week_name"
            :label="item.week_setting_item.week_name"
            :value="item.week_setting_item.week_name"
          >
          </el-option>
        </el-select>
        <span v-if="radio === 'staff'" style="margin-left: 20px">周数：</span>
        <el-select
          v-if="radio === 'staff'"
          v-model="selectValue2"
          @change="changeSelectValue2"
          placeholder="请选择"
          size="small"
          style="width: 120px"
        >
          <el-option
            v-for="item in datas.staff_performances_list"
            :key="item.week_setting.week_name"
            :label="item.week_setting.week_name"
            :value="item.week_setting.week_name"
          >
          </el-option>
        </el-select>
        <!-- 排序方法 业绩 完成率 活体-->
        <span v-if="radio === 'staff'" style="margin-left: 20px"
          >排序方法：</span
        >
        <el-select
          v-if="radio === 'staff'"
          v-model="sort"
          @change="changeSelectValue4"
          placeholder="请选择"
          size="small"
          style="width: 120px"
        >
          <el-option
            v-for="item in sortList"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="panel" v-if="radio === 'shop'">
        <div class="tableBox">
          <div class="tit1">
            <div
              class="cell1"
              style="
                border-right: 1px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
              "
            ></div>
            <div class="cell1">
              <div class="tit2">
                <div class="cell2">姓名</div>
                <div
                  class="cell2"
                  v-for="(item, index) in datas.week_setting_list"
                  :key="index"
                >
                  {{ item.week_name }}
                </div>
                <div class="cell2">业绩</div>
                <div class="cell2">活体</div>
                <div class="cell2">排名</div>
                <div class="cell2">月目标</div>
                <div class="cell2">完成度</div>
              </div>
            </div>
          </div>
          <div
            class="row1"
            v-for="(shop, shopIndex) in selectValue1Datas"
            :key="shopIndex"
          >
            <div
              class="cell1"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-right: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
              "
            >
              <span style="width: 100%; text-align: center">{{
                shop.shop_info.shop_name
              }}</span>
            </div>
            <div
              class="cell1"
              :style="{ 'background-color': shopIndex % 2 ? '' : '#FFF8F288' }"
            >
              <div
                class="row2"
                v-for="(staff, staffIndex) in shop.shop_performance_list"
                :key="staffIndex"
              >
                <div class="cell2">{{ staff.staff_info.staff_name }}</div>
                <div
                  class="cell2"
                  v-for="(week, weekIndex) in staff.week_performance_list"
                  :key="weekIndex"
                >
                  {{ week.toFixed(2) }}
                </div>
                <div class="cell2">
                  {{ staff.month_performance.toFixed(2) }}
                </div>
                <!-- 活体 -->
                <div class="cell2">{{ staff.pet_sale_count }}</div>
                <div class="cell2">{{ staffIndex + 1 }}</div>
                <div class="cell2">{{ staff.month_target.toFixed(2) }}</div>
                <div class="cell2">
                  {{ staff.month_rate === -1 ? "--" : staff.month_rate + "%" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel" v-if="radio === 'branch'">
        <div class="tableBox">
          <div class="tit1">
            <div
              class="cell1"
              style="
                border-right: 1px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
              "
            ></div>
            <div class="cell1">
              <div class="tit2">
                <div class="cell2">项目</div>
                <div
                  class="cell2"
                  v-for="(item, index) in selectValue3Datas[0]
                    .branch_shop_week_data_detail_list"
                  :key="index"
                >
                  {{ item.shop_info.shop_name }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="row1"
            v-for="(branch, branchIndex) in selectValue3Datas"
            :key="branchIndex"
          >
            <div
              class="cell1"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-right: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
              "
            >
              <span style="width: 100%; text-align: center">{{
                branch.branch_name
              }}</span>
            </div>
            <div
              class="cell1"
              :style="{
                'background-color': branchIndex % 2 ? '' : '#FFF8F288',
              }"
            >
              <div
                class="row2"
                v-for="(label, labelIndex) in [
                  '月业绩目标',
                  '周业绩目标',
                  '周业绩',
                  '周业绩完成率',
                  '周排名',
                ]"
                :key="labelIndex"
              >
                <div class="cell2">{{ label }}</div>
                <div
                  class="cell2"
                  v-for="(
                    shopItem, shopItemIndex
                  ) in branch.branch_shop_week_data_detail_list"
                  :key="shopItemIndex"
                >
                  <span v-if="label === '月业绩目标'">{{
                    shopItem.month_target.toFixed(2)
                  }}</span>
                  <span v-if="label === '周业绩目标'">{{
                    shopItem.week_target.toFixed(2)
                  }}</span>
                  <span v-if="label === '周业绩'">{{
                    shopItem.week_performance.toFixed(2)
                  }}</span>
                  <span v-if="label === '周业绩完成率'"
                    >{{ shopItem.week_rate.toFixed(2) }}%</span
                  >
                  <span v-if="label === '周排名'">{{ shopItem.week_num }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel" v-if="radio === 'staff'">
        <div class="tableBox">
          <div class="tit1">
            <div
              class="cell1"
              style="
                border-right: 1px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
              "
            ></div>
            <div class="cell1">
              <div class="tit2">
                <div class="cell2" style="width: 80px; flex-shrink: 0">
                  排名
                </div>
                <div
                  class="cell2"
                  :style="{ 'background-color': index % 2 ? '' : '#E3EBFF' }"
                  v-for="(item, index) in selectValue2Datas"
                  :key="index"
                >
                  {{ item.department }}
                </div>
              </div>
            </div>
          </div>

          <div class="row1">
            <div
              class="cell1"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-right: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
              "
            >
              <span style="width: 100%; text-align: center"></span>
            </div>
            <div class="cell1">
              <div class="row2">
                <div class="cell2" style="width: 80px; flex-shrink: 0">
                  <div style="display: flex; border-bottom: 1px solid #e6e6e6">
                    <div style="text-align: center; width: 100%"></div>
                  </div>
                </div>
                <div
                  class="cell2"
                  v-for="(item, itemIndex) in selectValue2Datas"
                  :key="itemIndex"
                >
                  <div style="display: flex; border-bottom: 1px solid #e6e6e6">
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      姓名
                    </div>
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      业绩
                    </div>
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      {{ selectValue2 == "全部" ? "月目标" : "周目标" }}
                    </div>
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      完成率
                    </div>
                    <div style="text-align: center; width: 100%">活体</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row1">
            <div
              class="cell1"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-right: 1px solid #e6e6e6;
                border-bottom: 1px solid #e6e6e6;
                border-left: 1px solid #e6e6e6;
              "
            >
              <span style="width: 100%; text-align: center">{{
                selectValue2
              }}</span>
            </div>
            <div class="cell1">
              <div class="row2">
                <div class="cell2" style="width: 80px; flex-shrink: 0">
                  <div
                    v-for="(num, numIndex) in totalMax"
                    :key="numIndex"
                    style="display: flex; border-bottom: 1px solid #e6e6e6"
                  >
                    <div style="text-align: center; width: 100%">{{ num }}</div>
                  </div>
                </div>
                <div
                  class="cell2"
                  v-for="(item, itemIndex) in selectValue2Datas"
                  :key="itemIndex"
                >
                  <div
                    v-for="(staff, staffIndex) in item.staff_detail_list"
                    :key="staffIndex"
                    style="display: flex; border-bottom: 1px solid #e6e6e6"
                  >
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      {{ staff.staff_info.staff_name }}
                    </div>
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      {{ staff.performance.toFixed(2) }}
                    </div>
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      {{ !staff.target ? "0" : staff.target.toFixed(2) }}
                    </div>
                    <div
                      style="
                        text-align: center;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;
                      "
                    >
                      {{ staff.rate.toFixed(2) }}%
                    </div>
                    <div style="text-align: center; width: 100%">
                      {{ staff.pet_sale_count }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      isShow: false,
      sort: "",
      sortList: [
        {
          value: "",
          label: "业绩高低",
        },
        {
          value: "1",
          label: "完成率高低",
        },
        {
          value: "2",
          label: "活体高低",
        },
      ],
      radio: "shop",
      state1: false,
      selectValue1: "",
      selectValue1Datas: [],
      selectValue2: "",
      selectValue2Datas: [],
      selectValue3: "",
      selectValue3Datas: [],
      totalMax: 1,
      datas: {
        shop_performance_list: [],
        staff_performances_list: [],
      },
    };
  },
  computed: {},
  props: {
    refresh: {
      default: 0,
    },
  },
  watch: {
    refresh() {
      this.getDatas();
    },
  },
  created() {
    this.getDatas();
  },
  mounted() {
    // this.myChart0 = echarts.init(document.getElementById("myChart0"));
    // this.myChart1 = echarts.init(document.getElementById("myChart1"));
  },
  methods: {
    changeSelectValue1() {
      for (let i = 0; i < this.datas.shop_performance_list.length; i++) {
        if (
          this.datas.shop_performance_list[i].department === this.selectValue1
        ) {
          this.selectValue1Datas =
            this.datas.shop_performance_list[i].department_performance_List;
        }
      }
    },
    changeSelectValue2() {
      for (let i = 0; i < this.datas.staff_performances_list.length; i++) {
        if (
          this.datas.staff_performances_list[i].week_setting.week_name ===
          this.selectValue2
        ) {
          this.selectValue2Datas =
            this.datas.staff_performances_list[i].depart_item_list;
        }
      }
      for (let i = 0; i < this.selectValue2Datas.length; i++) {
        if (
          this.selectValue2Datas[i].staff_detail_list.length > this.totalMax
        ) {
          this.totalMax = this.selectValue2Datas[i].staff_detail_list.length;
        }
        this.selectValue2Datas[i].staff_detail_list.forEach((item) => {
          item.rate = !item.target ? 0 : (item.performance / item.target) * 100;
        });
      }
      this.changeSelectValue4();
      console.log(this.selectValue2Datas, "selectValue2Datas---");
    },
    changeSelectValue3() {
      for (let i = 0; i < this.datas.branch_performances_list.length; i++) {
        if (
          this.datas.branch_performances_list[i].week_setting_item.week_name ===
          this.selectValue3
        ) {
          this.selectValue3Datas =
            this.datas.branch_performances_list[i].branch_Week_Data_Detail_list;
        }
      }
    },
    changeSelectValue4() {
      let sort = this.sort;
      console.log(this.selectValue2Datas, "sort");
      for (let i = 0; i < this.selectValue2Datas.length; i++) {
        console.log(i);
        if (sort == "") {
          this.selectValue2Datas[i].staff_detail_list = this.selectValue2Datas[
            i
          ].staff_detail_list.sort(
            (a, b) => b.performance * 100 - a.performance * 100
          );
        } else if (sort == "1") {
          console.log("完成率");
          this.selectValue2Datas[i].staff_detail_list = this.selectValue2Datas[
            i
          ].staff_detail_list.sort(
            (a, b) => b.rate.toFixed(2) - a.rate.toFixed(2)
          );
        } else if (sort == 2) {
          this.selectValue2Datas[i].staff_detail_list = this.selectValue2Datas[
            i
          ].staff_detail_list.sort((a, b) =>
            !b.pet_sale_count - a.pet_sale_count
              ? 1
              : b.pet_sale_count - a.pet_sale_count
          );
        }
      }
    },

    getDatas() {
      this.state1 = false;
      let params = {
        month_info: this.$public.FTime(
          sessionStorage.getItem("pkMonth"),
          "YYYY-MM"
        ), // 月份信息(2021-10)
      };
      this.isShow = true;
      // let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_Url9 +
            "api/ShopPerformancePKService/StaffPerformancePKReturnViewNew",
          params
        )
        .then((res) => {
          // loading.close();
          this.isShow = false;
          this.datas = res.data;
          // console.log(this.datas, "数据11111111111111");

          this.selectValue1 = this.datas.shop_performance_list[0].department;
          this.changeSelectValue1();
          this.selectValue2 =
            this.datas.staff_performances_list[0].week_setting.week_name;
          this.changeSelectValue2();
          this.selectValue3 =
            this.datas.branch_performances_list[0].week_setting_item.week_name;
          this.changeSelectValue3();
          // this.$nextTick(()=>{
          // 	this.state1 = true;
          // 	this.draw0()
          // 	this.draw1()
          // })
        });
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  width: 100%;
  background-color: #fff;
  .panel {
    padding: 22px 20px;
    box-sizing: border-box;
    width: 100%;
    .tableBox {
      .tit1 {
        display: flex;
        line-height: 52px;
        .cell1 {
          background-color: #f3f5fa;
          &:first-child {
            width: 70px;
          }
          &:last-child {
            width: calc(100% - 70px);
          }
          .tit2 {
            display: flex;
            width: 100%;
            .cell2 {
              width: 100%;
              text-align: center;
              border-right: 1px solid #e6e6e6;
            }
          }
        }
      }
      .row1 {
        display: flex;
        .cell1 {
          &:first-child {
            width: 70px;
            background-color: #f3f5fa;
          }
          &:last-child {
            width: calc(100% - 70px);
          }
          .row2 {
            display: flex;
            width: 100%;
            .cell2 {
              width: 100%;
              line-height: 52px;
              text-align: center;
              border-bottom: 1px solid #e6e6e6;
              border-right: 1px solid #e6e6e6;
            }
          }
        }
      }
    }
  }
}
</style>
